export default {
  activeReport: '',
  activeFilters: {},
  activeControls: {},
}
